import type { SocialApplyStatus } from "@bbj-types/socialApply/enum";
import { useCallback } from "react";
import { axios } from "../axios";

export const useGetSocialOfferApplyCount = () => {
  const [state, execute, cancel] = axios<Record<SocialApplyStatus, number>>(
    {
      method: "get",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (id: string) => {
      return execute({
        url: `/v2/offers/social/${id}/apply/count`,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
